import { jsx as r, jsxs as o } from "react/jsx-runtime";
import t from "./index.es5651.js";
import f from "classnames";
import { BaseHeader as p } from "./index.es5536.js";
import { ColorIndicator as u } from "./index.es26.js";
import { BodyText as l } from "./index.es487.js";
const E = "data-grid-multiline-header", H = ({
  entityColor: a,
  displayName: e,
  gridDensity: s,
  description: n,
  title: d,
  testId: i = E,
  ...m
}) => {
  const c = f(t.root, t[s]);
  return /* @__PURE__ */ r(p, { displayName: e, ...m, testId: i, children: /* @__PURE__ */ o("div", { className: c, "data-testid": i + "-multiline-container", children: [
    !!a && /* @__PURE__ */ r(
      u,
      {
        entityColor: a,
        testId: i + "-color-indicator"
      }
    ),
    /* @__PURE__ */ o("div", { className: t.info, "data-testid": i + "-info-container", children: [
      /* @__PURE__ */ r(
        l,
        {
          size: "default",
          variant: "bold",
          isEllipsis: !0,
          "data-testid": i + "-title",
          children: d || e
        }
      ),
      /* @__PURE__ */ r(
        l,
        {
          size: "small",
          variant: "regular",
          isEllipsis: !0,
          "data-testid": i + "-description",
          children: n
        }
      )
    ] })
  ] }) });
};
export {
  E as DEFAULT_MULTILINE_HEADER_TESTID,
  H as MultilineHeader
};
//# sourceMappingURL=index.es636.js.map
